import { differenceInCalendarDays } from 'date-fns';
import { Hotel } from 'types';

export namespace SelectedHotelPersistenceData {
  const HOTEL_DETAILS_ARGS_KEY = 'hotel_details_persistance_args';

  const read = (): Hotel.HotelDetailsPersistenceArgs[] => {
    try {
      const json = localStorage.getItem(HOTEL_DETAILS_ARGS_KEY);

      if (!json) {
        return [];
      }
      const parsed = JSON.parse(json) as Hotel.HotelDetailsPersistenceArgs[];
      return parsed;
    } catch (e) {
      return [];
    }
  };

  export const toPersistanceArg = (arg: Hotel.HotelDetailsPersistenceArgs) => {
    try {
      const list = read()
        .filter(it => differenceInCalendarDays(new Date(), it.updatedAt) <= 1)
        .filter(it => it.hotel?.id != arg.hotel?.id);

      list.push(arg);
      localStorage.setItem(HOTEL_DETAILS_ARGS_KEY, JSON.stringify(list));
    } catch (e) {
      localStorage.setItem(HOTEL_DETAILS_ARGS_KEY, JSON.stringify([arg]));
    }
  };

  export const getPersistanceById = (
    id: string,
  ): Hotel.HotelDetailsPersistenceArgs => {
    try {
      return read().find(it => it.hotel?.id === id);
    } catch {
      return null;
    }
  };
}
